<template>
  <div v-if="!onlyMyBtn">
    <div
      v-show="show"
      :class="['developer-info', showBgblue ? 'developer-info-blue' : '']"
    >
      <div class="logo">
        <img src="../../assets/img/logo1.png" alt="logo" />
      </div>
      <div v-if="!showNotice" class="description">{{ $t("projectOrder.informationCenter") }}</div>
      <div v-if="showNotice" class="description" style="display: flex; align-items: center;">
        <div style="margin-right: 10px; background: #fff;">
          <img style="width: 30px; height: 30px;position: relative; top: 2px;" src="../../assets/img/通知.png" alt="通知" />
        </div>
        <div style="color: red;">
          <div>重要通知：为更好的服务您进行订单交付管理，请您尽快激活飞书账号（已激活请忽视），系统近期将校验未激活则无法下单,</div>
          <div><a href="https://oppeinlink.feishu.cn/wiki/UUZTwgxgiiA2pXkg41Xc6u2snVe" style="color: red; text-decoration: underline;"  target="_blank">
            激活链接：https://oppeinlink.feishu.cn/wiki/UUZTwgxgiiA2pXkg41Xc6u2snVe></a></div>
        </div>
      </div>
      <el-dropdown
        v-if="isShowMyBtn"
        class="developer-info-dropdown"
        @command="handleCommand"
      >
        <span class="el-dropdown-link">
          我的<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in commandOptions"
            :key="item.value"
            :command="item.value"
            :disabled="item.disabled"
            >{{ item.label }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <configSettingDialog
      v-if="isDialogVisible"
      :visible.sync="isDialogVisible"
      :permissions="permissions"
    />
  </div>
  <el-dropdown v-else class="developer-info-dropdown" @command="handleCommand">
    <!-- <el-button plain size="small" class="el-dropdown-link myBtn">
      <div class="color2980">
        <i class="el-icon-user"></i>
        <span>我的</span><i class="el-icon-arrow-down el-icon--right"></i>
      </div>
    </el-button> -->
    <div class="color2980">
        <i class="el-icon-user"></i>
        <span>{{ user.name }}</span><i class="el-icon-arrow-down el-icon--right"></i>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="item in commandOptions"
        :key="item.value"
        :command="item.value"
        :disabled="item.disabled"
        >{{ item.label }}</el-dropdown-item
      >
      <configSettingDialog
        v-if="isDialogVisible"
        :visible.sync="isDialogVisible"
        :permissions="permissions"
      />
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import configSettingDialog from "@/components/developerInfo/components/configSettingDialog.vue";
import { getPermissionList } from "@oppein/op-utils";
import { api } from "@/api/index";

// 指定哪些路由展示该组件
const showRoutePathList = [
  "/placeOrderContent",
  "/confirmOrder",
  "/confirmCustomerInfo",
  "/check/caxa",
  "/check/software/moduleSelfTest",
  "/taskManagement/caxa",
  "/SplitOrderDetails",
  "/pptTemplateList",
  "/pptTemplateSelect",
  "/localImageManage",
  "/pptEditor",
  "/pptTemplateEditor",
  "/relevanceCustomer",
  "/pptDesign",
  "/caxaOneStepOrder2",
  "/caxaOneStepProject",
  "/caxaOneStepOrderByCustomer/retail",
  "/caxaOneStepProjectGc",
  // "/caxaOneStepProjectGc/mtdsGcOrder",
  // "/caxaOneStepOrderByCustomer/mtdsOrCustomerOrder",
];
import { getCookie, getQueryString } from "@/util/extends/cookieExpand";

export default {
  props: {
    /**
     * 仅显示我的按钮
     * @type {Boolean}
     */
    onlyMyBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      user: this.$store.state.authModule.user,
      isDialogVisible: false,
      loading: false,
      permissions: ["CustomerPersonalSettingBtn"],
    };
  },
  components: {
    configSettingDialog,
  },
  computed: {
    show() {
      const { path } = this.$route;
      return showRoutePathList.some((item) => path.includes(item) && !path.includes("/caxaOneStepProjectGc/mtdsGcOrder"));
    },
    showNotice() {
      const { path } = this.$route;
      return (
        path.includes("/caxaOneStepOrderByCustomer/retail") ||
        path.includes("/placeOrderContent") ||
        path.includes("/confirmOrder") ||
        path.includes("/confirmCustomerInfo")
      );
    },
    showBgblue() {
      const { path } = this.$route;
      return (
        path.includes("/caxaOneStepOrderByCustomer/retail") ||
        path.includes("/caxaOneStepOrderByCustomer/mtdsOrCustomerOrder") ||
        path.includes("/caxaOneStepProjectGc") ||
        path.includes("/caxaOneStepProjectGc/mtdsGcOrder")
      );
    },
    isShowMyBtn() {
      const { path } = this.$route;
      return (
        (this.isShowSetting || this.showChange) &&
        !path.includes("/caxaOneStepOrderByCustomer/retail")
      );
    },
    isShowSetting() {
      const { path } = this.$route;
      return (
        path.includes("/caxaOneStepOrder2") ||
        path.includes("/caxaOneStepOrderByCustomer/mtdsOrCustomerOrder") ||
        path.includes("/caxaOneStepOrderByCustomer/retail")
      );
    },
    showChange() {
      const { path } = this.$route;
      return (
        path.includes("/caxaOneStepOrder2") ||
        path.includes("/caxaOneStepOrderByCustomer/retail")
      );
    },
    /**
     * 菜单选项
     * @returns {Array}
     */
    commandOptions() {
      const list = [
        {
          label: "设置",
          value: "oppeinToSetting",
          disabled: !this.isShowSetting,
        },
        {
          label: "切换工程",
          value: "oppeinToproject",
          disabled: !this.showChange,
        },
        {
          label: "切换外贸",
          value: "oppeinToprojectWm",
          disabled: !this.showChange,
        },
      ];

      return list.filter((item) => {
        return !item.disabled;
      });
    },
  },
  methods: {
    goToProject() {
      // sessionStorage.removeItem('dictionarys')
      // sessionStorage.removeItem('orderForm')
      //window.location.reload()
      // let files=[...new Set(this.checkList)]
      let token =
        getQueryString("Oauth2-AccessToken") ||
        getCookie("Oauth2-AccessToken") ||
        "";
      let port = sessionStorage.getItem("caxa-websocket-port") || "";
      window.location.href = `${location.origin}/confirmCustomerInfo?Oauth2-AccessToken=${token}&port=${port}&businessTypeChange=oppeinToproject`;
      //if(!this.showChange){
      // sessionStorage.removeItem('dictionarys')
      // sessionStorage.removeItem('orderForm')
      // sessionStorage.setItem('businessTypeChange','oppeinToproject')
      // sessionStorage.setItem("businessType", 'project')
      // localStorage.setItem('businessType', sessionStorage.getItem('businessType'))
      //}
    },
    goToProjectWm() {
      // let files=[...new Set(this.checkList)]
      let token =
        getQueryString("Oauth2-AccessToken") ||
        getCookie("Oauth2-AccessToken") ||
        "";
      let port = sessionStorage.getItem("caxa-websocket-port") || "";
      window.location.href = `${location.origin}/caxaOneStepProject?Oauth2-AccessToken=${token}&port=${port}&businessTypeChange=oppeinToprojectWm`;
      //if(!this.showChange){
      // sessionStorage.removeItem('dictionarys')
      // sessionStorage.removeItem('orderForm')
      // sessionStorage.setItem('businessTypeChange','oppeinToprojectWm')
      // sessionStorage.setItem("businessType", 'project')
      // localStorage.setItem('businessType', sessionStorage.getItem('businessType'))
      //}
    },
    /**
     * 处理指令
     * @param command
     */
    handleCommand(command) {
      if (command === "oppeinToSetting") {
        this.isDialogVisible = true;
      } else if (command === "oppeinToproject") {
        this.goToProject();
      } else if (command === "oppeinToprojectWm") {
        this.goToProjectWm();
      }
    },
    /**
     * 处理权限
     */
    async handlePermission() {
      const permissionList = await getPermissionList("MTDS");
      const hasCustomerFunctionSettingBtnPermission = permissionList.some(
        (item) => item.permission === "CustomerFunctionSettingBtn",
      );
      this.permissions = hasCustomerFunctionSettingBtnPermission
        ? ["CustomerFunctionSettingBtn", "CustomerPersonalSettingBtn"]
        : ["CustomerPersonalSettingBtn"];
    },
    /**
     * 设置用户配置
     */
    async setUserSetting() {
      try {
        let res = await api.order.queryUserSetting();
        if (res.status) {
          sessionStorage.setItem(
            "splitMode",
            res.data && res.data.taskModel ? res.data.taskModel : "0",
          );
          this.setSessionItem(
            "splitButton",
            res.data && res.data.splitButton ? res.data.splitButton : "0",
          );
        }
      } catch (err) {
        // console.err(err);
      }
    },
  },
  mounted() {
    this.handlePermission();
    this.setUserSetting();
  },
};
</script>

<style lang="scss" scoped>
.developer-info {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background: #fbd39f;

  /**
  * tips：该position样式设置无特殊意义，只为解决一个异常现象，引起该问题的原因有待研究
  * 异常现象：由caxa唤起的浏览器打开一键下单页面，该元素背景颜色显示为白色即没有背景颜色
  * 但获取该元素背景颜色样式时值确实是设置的rgb(251, 211, 159)也就是#fbd39f
  * 解决：1、设置position: relative后恢复正常；2、拖动浏览器窗口大小后背景颜色也恢复正常
  */
  position: relative;

  .logo {
    line-height: 0;

    img {
      width: 180px;
      margin-right: 16px;
    }
  }
  .developer-config {
    position: absolute;
    right: 10px;
    font-size: 18px;
  }
  .description {
    font-size: 16px;
  }
  .developer-info-dropdown {
    position: absolute;
    right: 10px;

    .el-dropdown-link {
      cursor: pointer;
      color: #409eff;
      font-size: 16px;
    }
    .el-icon-arrow-down {
      font-size: 14px;
    }
  }
}
.developer-info-blue {
  background: #dfefff;
}
.developer-info-dropdown {
  .el-button--primary {
    // background-color: #2980ff;
    // border-color: #2980ff;
    // border: 1px solid #2980ff;
    border: 1px solid #2980ff;
    color: #2980ff;
    height: 30px;
    width: 80px;
  }
  .color2980 {
    color: #2980ff;
    margin-bottom: 8px;
  }
  .el-button--primary:focus,
  .el-button--primary:hover {
    background-color: rgba($color: #2980ff, $alpha: 0.7);
    border-color: rgba($color: #2980ff, $alpha: 0.7);
  }
  .myBtn {
    border: 1px solid #2980ff;
    color: #2980ff;
  }
  .myBtn:focus,
  .myBtn:hover {
    background-color: rgba($color: #2980ff, $alpha: 0.7);
    border-color: rgba($color: #2980ff, $alpha: 0.7);
    color: #fff;
  }
  .color2980:focus,
  .color2980:hover {
    //color: #fff;
    cursor: pointer;
  }
  .myBtn:hover .color2980 {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?7da27e13